import { filter, fromEvent, map, Subject } from 'rxjs';
import { associateWith } from '@ps-gui/shared-utils';
import { signal, Signal } from '@angular/core';

interface KeyStates {
  up: Subject<void>;
  down: Subject<void>;
  isPressed: Signal<boolean>;
}

const createKeyStates = (): KeyStates => {
  const up = new Subject<void>();
  const down = new Subject<void>();
  const isPressed = signal(false);
  up.pipe(map(() => false)).subscribe(() => isPressed.set(false));
  down.pipe(map(() => true)).subscribe(() => isPressed.set(true));
  return {
    up,
    down,
    isPressed,
  };
};

export const Keys = associateWith(['Enter', 'Control', 'Escape', 'Alt'], (_) => createKeyStates());

export const initializeKeyStates = () => {
  fromEvent<KeyboardEvent>(window, 'keydown').subscribe((event) => {
    Keys[event.key as keyof typeof Keys]?.down.next();
  });
  fromEvent<KeyboardEvent>(window, 'keyup').subscribe((event) =>
    Keys[event.key as keyof typeof Keys]?.up.next(),
  );
};

/**
 * Since I am not sure how to integrate this into the normal key state handling
 * I just leave this here as a utility.
 */
export const onKeyPressCapture = (keyCode: string) =>
  fromEvent<KeyboardEvent>(window, 'keydown', { capture: true }).pipe(
    filter((event) => event.key === keyCode),
  );
